import {
  SIDE_BY_SIDE_LANDSCAPE_ASPECT_RATIO,
  SIDE_BY_SIDE_PORTRAIT_ASPECT_RATIO,
} from "../../EditLayout/mediaSpecs";
import { css } from "@emotion/react";
import { styleUtils, theme } from "@minted/minted-components";
import React, { memo } from "react";

/**
 * A portrait and a landscape photo in a row, each grown in proportion to its
 * own slot spec (modularMediaSpecs.sideBySide) so the two match in height.
 */
const styles = {
  image: (aspectRatio: number) => css`
    aspect-ratio: ${aspectRatio};
    display: block;
    flex-basis: 0;
    flex-grow: ${aspectRatio};
    flex-shrink: 1;
    min-width: 0;
    object-fit: cover;
  `,
  row: css`
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing.x2};
    width: 100%;
  `,
  viewport: css`
    margin-bottom: ${styleUtils.rem(30)};
    width: 100%;
  `,
};

export type SideBySideMediaProps = {
  alt: string;
  leftPhotoURL: string;
  rightPhotoURL: string;
};

const SideBySideMedia = ({
  alt,
  leftPhotoURL,
  rightPhotoURL,
}: SideBySideMediaProps) => (
  <div css={styles.viewport} data-cy="sideBySideMedia">
    <div css={styles.row}>
      <img
        alt={alt}
        css={styles.image(SIDE_BY_SIDE_PORTRAIT_ASPECT_RATIO)}
        data-cy="leftImage"
        src={leftPhotoURL}
      />
      <img
        alt={alt}
        css={styles.image(SIDE_BY_SIDE_LANDSCAPE_ASPECT_RATIO)}
        data-cy="rightImage"
        src={rightPhotoURL}
      />
    </div>
  </div>
);

const MemoizedSideBySideMedia = memo(SideBySideMedia);

export { MemoizedSideBySideMedia as SideBySideMedia };
